import { render, staticRenderFns } from "./addPromotionalBelt.vue?vue&type=template&id=6927a51e&scoped=true&"
import script from "./addPromotionalBelt.vue?vue&type=script&lang=js&"
export * from "./addPromotionalBelt.vue?vue&type=script&lang=js&"
import style0 from "./addPromotionalBelt.vue?vue&type=style&index=0&id=6927a51e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6927a51e",
  null
  
)

component.options.__file = "addPromotionalBelt.vue"
export default component.exports